// import jwtDecode from 'jwt-decode';
import axiosHub from 'src/utils/axiosHub';
import axiosHubAuth from 'src/utils/axiosAuth';
import axiosIntegration from 'src/utils/axiosIntegration';
import { errorHandler } from './requests';
import jwt_decode from 'jwt-decode';

class AuthService {
  setAxiosInterceptors = ({ onLogout }) => {
    axiosHubAuth.interceptors.response.use(
      response => response,
      error => {
        if (error.response && error.response.status === 401) {
          this.setSession(null);

          if (onLogout) {
            onLogout();
          }
        }

        return Promise.reject(error);
      }
    );
  };

  handleAuthentication() {
    const accessToken = this.getAccessToken();

    if (this.isValidToken(accessToken)) {
      this.setSession(accessToken);
    } else {
      this.setSession(null);
    }
  }

  loginWithEmailAndPasswordHub = async (username, password) =>
    new Promise((resolve, reject) => {
      const dataPost = {
        username,
        password,
      };

      axiosHubAuth
        .post(
          dataPost.username === 'master' ? '/Login/master' : '/login/Signin',
          dataPost
        )
        .then(response => {
          const { auth, name, idPartner, idCompany } = response.data;

          const decode = jwt_decode(auth);
          this.setSession(auth, idCompany);
          resolve({
            name,
            idPartner,
            idCompany,
            perfil: decode.role,
          });
        })
        .catch(error => {
          const status = error?.response?.status;
          const authBaseUrl = axiosHubAuth?.defaults?.baseURL || '(vazio)';

          if (status === 500) {
            reject('API não instalada corretamente.');
            return;
          }

          if (status === 404) {
            reject(
              `Configuração de caminho da API incorreta. BaseURL atual: ${authBaseUrl}`
            );
            return;
          }

          reject(error?.response?.data || error?.message || 'Erro no login');
        });
    });

  loginInWithTokenHub = () =>
    new Promise((resolve, reject) => {
      axiosHubAuth
        .post('/login/session')
        .then(response => {
          if (response.data) {
            const { auth, name } = response.data;

            const user = {
              name,
              auth,
            };

            this.setSession(auth);
            resolve(user);
          } else {
            const messages = errorHandler(response);
            reject(messages);
          }
        })
        .catch(error => {
          const messages = errorHandler(error);

          reject(messages);
        });
    });

  changeCompanyToken = idCompany =>
    new Promise((resolve, reject) => {
      const data = {
        idCompany,
        token: this.getAccessToken,
      };

      axiosHubAuth
        .post('/login/changetoken', data)
        .then(response => {
          if (response.data) {
            const { auth, name } = response.data;

            this.setSession(auth);
            resolve(name);
          } else {
            const messages = errorHandler(response);
            reject(messages);
          }
        })
        .catch(error => {
          const messages = errorHandler(error);

          reject(messages);
        });
    });

  logout = () => {
    this.setSession(null);
    localStorage.removeItem('configuration');
    localStorage.removeItem('debugger');
    localStorage.removeItem('debugger-status');
    localStorage.removeItem('debugger-path');
    localStorage.removeItem('report-production-area');
    localStorage.removeItem('idCompany');
  };

  setSession = (accessToken, id) => {
    if (accessToken) {
      localStorage.setItem('accessToken', accessToken);

      if (!!id) {
        localStorage.setItem('idCompany', id);
      }

      axiosHub.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
      axiosHubAuth.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
      axiosIntegration.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    } else {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('idCompany');
      delete axiosHub.defaults.headers.common.Authorization;
      delete axiosHubAuth.defaults.headers.common.Authorization;
      delete axiosIntegration.defaults.headers.common.Authorization;
    }
  };

  getAccessToken = () => localStorage.getItem('accessToken');

  isValidToken = accessToken => {
    if (!accessToken) {
      return false;
    }

    return true;
  };

  isAuthenticated = () => !!this.getAccessToken();

  changeCompanyToken = idCompany =>
    new Promise((resolve, reject) => {
      const data = {
        idCompany,
        token: localStorage.getItem('accessToken'),
      };

      axiosHubAuth
        .post('/login/changetoken', data)
        .then(response => {
          if (response.data) {
            const { auth, name } = response.data;

            this.setSession(auth, idCompany);
            resolve(name);
          } else {
            const messages = errorHandler(response);
            reject(messages);
          }
        })
        .catch(error => {
          const messages = errorHandler(error);

          reject(messages);
        });
    });
}

const authService = new AuthService();

export default authService;
